import { render, staticRenderFns } from "./MessageScreen.vue?vue&type=template&id=610aab82&scoped=true"
import script from "./MessageScreen.vue?vue&type=script&lang=js"
export * from "./MessageScreen.vue?vue&type=script&lang=js"
import style0 from "./MessageScreen.vue?vue&type=style&index=0&id=610aab82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610aab82",
  null
  
)

export default component.exports